import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import ReadingMarker from './ReadingMarker';
import styles from './Marker.pcss';
const Marker = (props)=>{
    useStyles(styles);
    const renderValue = (val)=>{
        if (typeof val === 'number') {
            return val ? val.toFixed(1) : '-';
        }
        return val;
    };
    if (props.type === 'overlapingInjections') {
        const { values, key } = props;
        return /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.marker__group, styles['marker--overlapingInjections']),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.marker, styles['marker--fastActing'], styles['marker--leftOverlaping']),
                    children: renderValue(values[0])
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.marker, styles['marker--longActing'], styles['marker--rightOverlaping']),
                    children: renderValue(values[1])
                })
            ]
        }, key);
    }
    if (props.type === 'reading') {
        const { reading, conversion, standards, key, className } = props;
        return /*#__PURE__*/ _jsx(ReadingMarker, {
            reading: reading,
            conversion: conversion,
            standards: standards,
            className: className
        }, key);
    }
    const { type, value, key, className } = props;
    return /*#__PURE__*/ _jsx("div", {
        className: cn(className, styles.marker, styles['marker--clip'], styles[`marker--${type}`]),
        children: /*#__PURE__*/ _jsx("div", {
            children: type !== 'activity' ? renderValue(value) : value || '-'
        })
    }, key);
};
export default Marker;
